import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { counterpartyModel } from '~/entities/Counterparty'
import {
  editCounterpartyModel,
  EditCounterparty,
} from '~/features/Counterparties/EditCounterparty'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditCounterpartyPage = () => {
  const { t } = useTranslation()
  const { counterpartyId } = useParams<{ counterpartyId: string }>()

  const isLoading = useStore(counterpartyModel.requestFx.pending)
  const name = useStoreMap(
    editCounterpartyModel.$counterparty,
    (counterparty) => counterparty?.getName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { titleI18n: 'counterparties', link: '/counterparties' },
      { title: name || '' },
    ],
    [name],
  )

  const error = counterpartyModel.useCounterpartyError(counterpartyId as string)

  if (!counterpartyId || error) {
    return <NotFound message={t('alert.counterparty load error')} />
  }

  return (
    <PageContainer title={t('counterparty card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{name}</PageTitle>
      </Container>

      <EditCounterparty counterpartyId={counterpartyId} />
    </PageContainer>
  )
}
